import { storageFactory } from './storageFactory';

/**
 * Create singelton objects that could influence
 * local storage and session storage
 */
export const localStore = storageFactory(localStorage);
export const sessionStore = storageFactory(sessionStorage);
